// eslint-disable-next-line max-classes-per-file
import { AxiosResponse } from 'axios';

import { instance as axios } from 'api/axios';

class MyError extends Error {
  errorExtraParamsGet;

  constructor(message: any, errorExtraParams: any) {
    super(message);
    this.errorExtraParamsGet = errorExtraParams;
  }

  get errorExtraParams() {
    return this.errorExtraParamsGet;
  }
}

export class smcCarsService {
  static prefix = '/SpecialList/White';

  public static async getSMCCars() {
    const url = `${smcCarsService.prefix}`;

    try {
      const response: AxiosResponse = await axios.get(url);
      return response.data;
    } catch (error: any) {
      throw new MyError(error, error.response);
    }
  }

  public static async addSMCCars(body: any) {
    const url = `${smcCarsService.prefix}`;

    try {
      const response: AxiosResponse<any> = await axios.post(url, body);
      return response.data;
    } catch (error: any) {
      throw new MyError(error, error.response);
    }
  }

  public static async deleteSMCCars(id: number) {
    const url = `${smcCarsService.prefix}/?id=${id}`;

    try {
      const response: AxiosResponse<any> = await axios.delete(url);
      return response.data;
    } catch (error: any) {
      throw new MyError(error, error.response);
    }
  }
}
